import { IgLink } from "@intelligems/ig-theme/IgLink";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Stack from "@mui/material/Stack";

interface DiscountSyncErrorToastProps {
  onClick: (ev: React.MouseEvent) => void;
}

// react-toastify renders toast content in its own container, which lives
// outside the <Router> tree — so this component must not call router hooks like
// `useNavigate()` (it throws "useNavigate() may be used only in the context of a
// <Router> component"). Navigation is handled by the caller instead.
export const DiscountSyncErrorToast = ({
  onClick,
}: DiscountSyncErrorToastProps) => {
  return (
    <Stack direction={"column"} onClick={onClick}>
      <IgTypography fontWeight={600}>
        Discount Synchronization Error
      </IgTypography>
      <IgTypography>
        Go to <IgLink>Merchandising</IgLink> to correct the error.
      </IgTypography>
    </Stack>
  );
};
